import { render, staticRenderFns } from "./phhome.vue?vue&type=template&id=5ed4aadb"
import script from "./phhome.vue?vue&type=script&lang=js"
export * from "./phhome.vue?vue&type=script&lang=js"
import style0 from "./phhome.vue?vue&type=style&index=0&id=5ed4aadb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports